
import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import _ from 'lodash';

import * as Icons from 'components/Svg';

export const Filter = ({children, size = 'm', filterId, onSelect, selected, ...props}) => {
  const onClick = e => onSelect?.(filterId);
  return (
    <div {...props} className={cx("g-filter", size, {selected})} onClick={onClick}>
      <span>{children}</span>
    </div>)
}

export const FilterList = ({children, ...props}) => {
  return (<div className={cx("g-filter-list")} {...props}>{children}</div>)
}


export const TagFilter = ({children, ...props}) => {
  return (<Filter {...props}><Icons.TagIcon size="m" />{children}</Filter>)
}

export const AllTagsFilter = ({children, ...props}) => {
  return (<Filter {...props}>{children}</Filter>)
}